import React from "react";
import cx from "classnames";
import YouTube from "react-youtube";
import { Link } from "src/components/link";
import { Reveal } from "src/components/reveal";
import { Image } from "src/components/image";
import { BlockContent } from "src/components/block-content";
import { BackgroundLines } from "src/components/background-lines";
import { CTA } from "src/components/cta";

import { getInternalLinkPath } from "src/utils/getInternalLinkPath";
// import BlockContent from "src/components/block-copy";

import styles from "./video-module.module.css";

interface VideoModuleProps {
  module: {
    label?: string;
    headline?: string;
    copy?: any;
    cta?: any;
    image: any;
    imageAlignment?: string;
    backgroundColor?: string;
    backgroundLines?: {
      type: string;
      color: string;
      alignment: string;
    };
    headlineSize?: string;
    videoEmbed: {
      service: string;
      id: string;
    };
  };
}
export const VideoModule = ({ module }: VideoModuleProps) => {
  const {
    label,
    headline,
    copy,
    cta,
    backgroundColor,
    backgroundLines,
    headlineSize,
    videoEmbed
  } = module;

  const embedOpts = {
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      modestbranding: 1
    }
  };

  return (
    <section className={cx(styles.videoModule, styles[`${backgroundColor}`])}>
      {backgroundLines && (
        <BackgroundLines
          type={backgroundLines.type}
          color={backgroundLines.color}
          alignment={backgroundLines.alignment}
        />
      )}
      <div className={styles.videoModuleInner}>
        <div className={cx(styles.copyColumn)}>
          <div className={styles.copyColumnInner}>
            <Reveal>
              {label && (
                <h4 className={cx("small-caps-13", styles.label)}>{label}</h4>
              )}
              {headline && (
                <h2
                  className={cx(
                    headlineSize === "large"
                      ? "headline headline--large"
                      : "headline",
                    styles.headline
                  )}
                >
                  {headline}
                </h2>
              )}
              {copy && <BlockContent className={styles.copy} blocks={copy} />}
            </Reveal>
          </div>
        </div>
        <Reveal className={styles.videoEmbed}>
          <YouTube
            containerClassName={styles.iframeContainer}
            videoId={videoEmbed.id}
            opts={embedOpts}
          />
        </Reveal>
      </div>
    </section>
  );
};
